import { render, staticRenderFns } from "./RelatorioPedido.vue?vue&type=template&id=5a3f328c"
import script from "./RelatorioPedido.vue?vue&type=script&lang=js"
export * from "./RelatorioPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports